import React, { useEffect, useState } from 'react';

import { ExpandMoreButton } from '@components/ExpandMoreButton';
import Collapse from '@material-ui/core/Collapse';
import { makeMuiStyles, useCommonStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  noticeItemTitle: {
    ...common.flexInline,
    padding: 10,
    [theme.breakpoints.up('lg')]: {
      padding: 20,
    },
  },
  dotOrange: {
    display: 'block',
    borderRadius: 10,
    backgroundColor: '#FA6400',
    width: 8,
    height: 8,
  },
  dotBlack: {
    display: 'block',
    borderRadius: 10,
    backgroundColor: theme.palette.text.primary,
    width: 8,
    height: 8,
  },
  textContainer: {
    ...common.flexColumn,
    marginLeft: 20,
    marginRight: 20,
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      ...common.flexInline,
    },
  },
  itemTitle: {
    ...common.normalText,
    fontWeight: 500,
    fontSize: 14,
    flex: 1,
    [theme.breakpoints.up('lg')]: {
      marginLeft: 20,
    },
  },
  dateString: {
    ...common.normalText,
    fontSize: 14,
    color: theme.palette.grey[500],
  },
  downContainer: {
    ...common.flexCenter,
    width: 10,
    [theme.breakpoints.up('lg')]: {
      marginLeft: 20,
    },
  },
  contentItem: {
    overflow: 'hidden',
    height: 0,
    paddingLeft: 20,
    paddingRight: 20,
    marginLeft: 20,
    marginRight: 20,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 52,
    },
  },
  container: {
    marginBottom: 19,
    overflow: 'hidden',
    backgroundColor: theme.palette.grey[50],
  },
  dotContainer: {
    ...common.flexCenter,
    width: 10,
  },
  down: {
    display: 'block',
    width: 16,
    height: 16,
  },
}));

export interface NotificationItemProps {
  hasRead?: boolean;
  onRead?: () => void;
  title: React.ReactNode;
  date: string;
}

export const NotificationItem: React.FC<React.PropsWithChildren<NotificationItemProps>> = (
  props,
) => {
  const { children, hasRead = false, onRead, title, date } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (expanded) {
      onRead?.();
    }
  }, [expanded]);

  return (
    <div className={classes.container}>
      <div className={classes.noticeItemTitle} onClick={() => setExpanded(!expanded)}>
        <div className={classes.dotContainer}>
          <span className={hasRead ? classes.dotBlack : classes.dotOrange} />
        </div>
        <div className={classes.textContainer}>
          <div className={classes.itemTitle}>{title}</div>
          <div className={classes.dateString}>{date}</div>
        </div>
        <div className={classes.downContainer}>
          <ExpandMoreButton expanded={expanded} />
        </div>
      </div>
      <Collapse in={expanded}>{children}</Collapse>
    </div>
  );
};
